import { ReactNode } from "react";
import { Stack, Typography, Box } from "@mui/material";

// Props Interface
interface SectionHeaderProps {
  title: string;
  subtitle?: string;
  icon?: ReactNode;
  action?: ReactNode;
  bg?: string;
  count?: number;
}

export default function DashHeader({
  title,
  subtitle,
  icon,
  action,
  bg,
  count,
}: SectionHeaderProps) {
  return (
    <Stack
      direction={{ xs: "column", sm: "row" }}
      alignItems={{ xs: "flex-start", sm: "center" }}
      justifyContent="space-between"
      spacing={2}
      sx={{
        mb: 3,
        px: { xs: 2, sm: 4 },
        py: { xs: 2, sm: 3 },
        borderTopLeftRadius: 12,
        borderTopRightRadius: 12,
        backgroundColor: bg || "#7D79C2",
        boxShadow: "0px 4px 24px rgba(0, 0, 0, 0.1)",
        border: "1px solid rgba(255,255,255,0.2)",
      }}
    >
      <Stack direction="row" alignItems="center" spacing={2} sx={{ width: "100%" }}>
        {icon && (
          <Box sx={{ color: "white", display: "flex", alignItems: "center" }}>
            {icon}
          </Box>
        )}
        <Box>
          <Typography
            variant="h5"
            fontWeight={600}
            color="white"
            sx={{ wordBreak: "break-word", display: "flex", alignItems: "center",fontSize:'1rem' }}
          >
            {title}
            {typeof count === "number" && (
              <Typography
                component="span"
                variant="subtitle2"
                sx={{
                  ml: 1.5,
                  backgroundColor: "rgba(255,255,255,0.2)",
                  px: 1.2,
                  py: 0.3,
                  borderRadius: 1,
                  color: "white",
                  fontSize: "0.8rem",
                }}
              >
                Total: {count}
              </Typography>
            )}
          </Typography>

          {subtitle && (
            <Typography
              variant="body2"
              sx={{ color: "rgba(255,255,255,0.85)", mt: 0.5, wordBreak: "break-word" }}
            >
              {subtitle}
            </Typography>
          )}
        </Box>
      </Stack>

      {action && (
        <Box sx={{ mt: { xs: 2, sm: 0 }, display: "flex", alignItems: "center" }}>
          {action}
        </Box>
      )}
    </Stack>
  );
}
